import { render } from "./EtsPlans.vue?vue&type=template&id=54878b42&scoped=true"
import script from "./EtsPlans.vue?vue&type=script&lang=js"
export * from "./EtsPlans.vue?vue&type=script&lang=js"

import "./EtsPlans.vue?vue&type=style&index=0&id=54878b42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54878b42"]])

export default __exports__